interface Props {
  en: string;
  title: string;
  desc?: string;
  actionLabel?: string;
}

export default function SectionHead({ en, title, desc, actionLabel }: Props) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div className="flex items-center gap-3">
          <span className="font-label inline-block rounded-md bg-primary-500 px-2 py-0.5 text-xs font-semibold tracking-[0.15em] text-background-50 uppercase">
            {en}
          </span>
          <span className="h-px w-10 bg-primary-300" />
        </div>
        <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{desc}</p>}
      </div>
      {actionLabel && (
        <a
          href="#tougao"
          className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-background-300 px-4 py-2 text-sm font-medium whitespace-nowrap text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </a>
      )}
    </div>
  );
}